module.exports = __webpack_public_path__ + "img/no-image.0ded3ed8.jpg";